import { DEFAULT_LOCALE, Locale } from '../commonFormatters'

/**
 * Static copy the renderers need — labels on controls the blocks draw themselves.
 *
 * This is not cms content: an editor never writes it, and it has to exist before any page does.
 * It is a plain typed object rather than a message catalogue, so adding a key is a type error in
 * every locale that has not supplied it — the compiler is the completeness check, and a missing
 * translation cannot reach a page as a silently empty string.
 */
export type CmsRendererTranslations = {
    video: {
        play: string
    }
    carousel: {
        previous: string
        next: string
        goToSlide: (index: number) => string
    }
    gallery: {
        open: string
        close: string
        imagePosition: (index: number, total: number) => string
    }
}

const hu: CmsRendererTranslations = {
    video: {
        play: 'Videó lejátszása',
    },
    carousel: {
        previous: 'Előző',
        next: 'Következő',
        goToSlide: (index) => `Ugrás a(z) ${index}. diára`,
    },
    gallery: {
        open: 'Kép megnyitása teljes méretben',
        close: 'Bezárás',
        imagePosition: (index, total) => `${index}. kép a(z) ${total} képből`,
    },
}

const en: CmsRendererTranslations = {
    video: {
        play: 'Play video',
    },
    carousel: {
        previous: 'Previous',
        next: 'Next',
        goToSlide: (index) => `Go to slide ${index}`,
    },
    gallery: {
        open: 'Open image full size',
        close: 'Close',
        imagePosition: (index, total) => `Image ${index} of ${total}`,
    },
}

const byLocale: Record<Locale, CmsRendererTranslations> = { hu, en }

export const getCmsTranslations = (locale: Locale | null | undefined): CmsRendererTranslations =>
    byLocale[locale ?? DEFAULT_LOCALE] ?? byLocale[DEFAULT_LOCALE]
